import { type HTMLTableCellProps } from '@/lib/types';
import styled from '@emotion/styled';

const StyledTableCell = styled('td')({
  height: 29,
});

// eslint-disable-next-line react-refresh/only-export-components
export const IconWrapper = styled('div')({
  marginBottom: -9,
  height: 32,
  display: 'inline-flex',
  alignItems: 'center',
});

const FileIconTableCell = ({ children, ...props }: HTMLTableCellProps) => (
  <StyledTableCell {...props}>
    <IconWrapper>{children}</IconWrapper>
  </StyledTableCell>
);

export default FileIconTableCell;
